// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-input-icon .fa-magnifying-glass{--tw-text-opacity:1;color:#1e1e1e;color:rgba(30,30,30,var(--tw-text-opacity,1))}.search-input-icon .fa-circle-xmark,.search-input-icon .fa-magnifying-glass{display:block;font-size:1.25rem;line-height:1.75rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
